<template>
    <div class="content-container">
        <form>
            <div class="name-row">
                <v-text-field class="first-name" label="First name" v-model="user.firstName" @blur="validateFirstName()" :error-messages="this.userErrors.firstNameErrors" outlined solo flat :height="50" color="#18125a"></v-text-field>
                <v-text-field label="Last name" v-model="user.lastName" @blur="validateLastName()" :error-messages="this.userErrors.lastNameErrors" outlined solo flat :height="50" color="#18125a"></v-text-field>
            </div>
            <v-text-field
                label="Email"
                type="email"
                v-model="user.email"
                @blur="validateEmail()"
                :error-messages="userErrors.emailErrors"
                outlined
                solo
                flat
                :height="50"
                color="#18125a"
            ></v-text-field>
            <v-text-field
                label="Password"
                type="password"
                v-model="user.password"
                @blur="validatePassword()"
                :error-messages="userErrors.passwordErrors"
                outlined
                solo
                flat
                :height="50"
                color="#18125a"
            ></v-text-field>
            <span>
                <p>
                    By signing up, you agree to our
                    <a>Terms & Conditions</a>
                </p>
                <button type="button" @click="validateForm">Sign up</button>
            </span>
        </form>
        <h1>
            Claim the
            <span class="secondary-color">only ad space</span> in your local area and start driving
            <span class="secondary-color">traffic that matters</span> to your business today
        </h1>
    </div>
</template>

<script>
export default {
    name: 'SignUpComponent',
    data: () => {
        return {
            user: {
				firstName: null,
				lastName: null,
				email: null,
				password: null
			},
			userErrors: {
				firstNameErrors: [],
				lastNameErrors: [],
                emailErrors: [],
                passwordErrors: []
			},
        }
    },
    methods: {
        validateForm() {
			if (this.validateEmail() & this.validateLastName() & this.validateFirstName() & this.validatePassword()) {
				this.$emit('signup', this.user);
			}
		},
		validateFirstName() {
			this.userErrors.firstNameErrors = [];
			if (!this.user.firstName) {
				this.userErrors.firstNameErrors.push('Your first name is required');
			}
			return !this.userErrors.firstNameErrors.length > 0;
		},
		validateLastName() {
			this.userErrors.lastNameErrors = [];
			if (!this.user.lastName) {
				this.userErrors.lastNameErrors.push('Your last name is required');
			}
			return !this.userErrors.lastNameErrors.length > 0;
		},
		validateEmail() {
			this.userErrors.emailErrors = [];
			if (!this.user.email) {
				this.userErrors.emailErrors.push('Your email is required');
			}
			var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			if (!re.test(String(this.user.email).toLowerCase())) {
				this.userErrors.emailErrors.push('Invalid email');
			}
			return !this.userErrors.emailErrors.length > 0;
		},
		validatePassword() {
			this.userErrors.passwordErrors = [];
			if (!this.user.password) {
				this.userErrors.passwordErrors.push("Don't forget your password!");
			}
			return !this.userErrors.passwordErrors.length > 0;
		},
    }
};
</script>

<style lang="scss" scoped>
    .content-container {
        height: 100%;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 80px;

        form {
            display: flex;
            flex-direction: column;
            // gap: 25px;
            width: 50%;
            max-width: 425px;
            margin-right: 50px;

            .name-row {
                display: flex;
                flex-direction: row;

                .first-name {
                    margin-right: 25px;
                }
            }

            button {
                background: #e79831;
                color: white;
                font-weight: bold;
                width: 100%;
                height: 50px;
                padding: 5px;
                border-radius: 5px;
                font-size: 1.2rem;
            }
        }

        h1 {
            font-size: 3rem;
            width: 50%;
            color: #18125a;
            max-width: 425px;
        }

        .secondary-color {
            color: #e79831;
        }
    }

    @media screen and (max-width: 1200px) {
        .content-container {
            h1 {
                font-size: 2.5rem;
                margin-bottom: 20px;
            }
        }
    }
    
    @media screen and (max-width: 750px) {
        .content-container {
            flex-direction: column-reverse;
            padding: 20px;

            h1 {
                font-size: 2rem;
                line-height: 2.5rem;
                width: 100%;
            }

            form {
                width: 100%;
                margin-right: 0;
            }
        }
    }
</style>